import { render, staticRenderFns } from "./pending-approvals-modal.vue?vue&type=template&id=066db53e"
import script from "./pending-approvals-modal.ts?vue&type=script&lang=js&external"
export * from "./pending-approvals-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports